import axios from "axios";
const CONTROLLER_PATH = "CustomerDependant";
class CustomerDependantService {
    //CREATE
    create(formData) {
        return axios
            .post(CONTROLLER_PATH, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }
    sendconsentsms(customerDependantId) {
        return axios.post(CONTROLLER_PATH + "/SendConsentSms/" + customerDependantId).then((response) => response.data);
    }
    //READ
    getOne(id) {
        return axios.get(CONTROLLER_PATH + "/" + id).then((response) => response.data);
    }
    getConsentSmsStatuses() {
        return axios.get(CONTROLLER_PATH + "/getConsentSmsStatuses").then((response) => ({
            data: response.data,
        }));
    }
    downloadDependantMedicalLegalConsentDocument(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/DownloadDependantMedicalLegalConsentDocument/", {
            params: urlParameters,
            responseType: 'blob'
        });
    }

    //UPDATE
    update(id, formData) {
        return axios
            .put(CONTROLLER_PATH + "/" + id, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }

    //DELETE
    delete(id) {
        return axios.delete(CONTROLLER_PATH + "/" + id).then(() => {});
    }
}

export default new CustomerDependantService();
